module.exports = __webpack_public_path__ + "img/TITAN.7999e7bb.png";